export type AuthenticationDetails = {
  env: string;
  user: { id: string; email: string; given_name: string; family_name: string };
  org: { id?: number; name?: string; alias?: string; description?: string };
  origin: string;
  version: string;
  tag: string;
  branch: string;
};

export type InitOptions = {
  service: string;
  isProduction: boolean;
  env: string;
  version: string;
  sha: string;
  tag: string;
  branch: string;
};

export type DeploymentEnvironment = "dev" | "uat" | "preprod" | "prod";
export function getDeploymentEnv(): DeploymentEnvironment {
  if (typeof window === "undefined") return "dev";

  const url = window.location.href;

  if (url.includes("app.artis.works")) return "prod";
  if (url.includes("preprod")) return "preprod";
  if (url.includes("uat") || url.includes("main")) return "uat";

  return "dev";
}
